import React from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";

function OperatorTenantListPage(props) {
    return (
        <>
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            deleteModalTitile={"Delete Campaign"}
                            deleteModalQuestion={"Are you sure you want to delete this Campaign?"}
                            editHref={"/campaign/update"}
                            detailsHref={"/campaign/details"}
                            objectKeys={["id", "currency.iso_code", "name", "provider_campaign_id", "contribution_type", "contribution_amount", "minimum_bet"]}
                            columnTitles={[
                                "ID", "Currency", "Name", "Provider Campaign ID", "Contribution Type", "Contribution Amount", "Minimum Bet"
                            ]}
                            insertHref={"/campaign/create"}
                            insertTitle={"Add Campaign"}
                            pageTitle={"Campaigns"}
                            deleteEndpoint={"campaign/delete"}
                            readEndpoint={"campaign/read"}
                            relations={["currency"]}
                            />
        </>
    )
}

export default OperatorTenantListPage;